import { Container, Divider, Slider, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import { useState } from "react";
import { Ring } from "@uiball/loaders";
import Spacebox from "../components/Spacebox";
import { isMobile } from "react-device-detect";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Button from "../components/Button";
import Toast from "../components/Toast";
import Grid from "../components/Grid";


const ApplyNow = ({ title }) => {
    document.querySelector('title').innerHTMl = title

    const [step, setStep] = useState(0)
    const maxStep = 4

    const [type, setType] = useState(false)

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [msg, setToastMsg] = useState('');
    const [loading, setLoading] = useState(false)

    const submit = () => {
        setLoading(true)
        post('https://services.leadconnectorhq.com/hooks/V4pKDZSxIDsVIxVlTrdd/webhook-trigger/5cf05a74-1302-480b-8fe9-994fc3d30011', () => {
            setStep(5) // show the iframe
        })

    }

    const post = (url, action) => {
        fetch(url,
            {
                mode: 'cors',
                method: 'POST',
                headers: { "Content-Type": "application/json", "Accept": "application/json", "Origin": "http://localhost:3000" },
                body: JSON.stringify({ amount, business_operating_time: businessOperatingTime, monthy_revenue: monthlyRevenue, credit_score: creditScore, firstname, lastname, businessName, email, phone })
            }
        ).then(res => {
            if (!res.ok)
                throw Error('Error occured: ', res.status)
            return res.json()
        }).then(res => {
            console.log(res)
            setLoading(false)
            setToastMsg("Successful")
            setSeverity('success')
            setOpen(true)
            action()
        }).catch(err => {
            console.log(err)
            setLoading(false)
            setToastMsg("An error occured")
            setSeverity('error')
            setOpen(true)
        })
    }


    const changeStep = (direction) => {

        if (verify(direction) === true) {
            document.querySelector(".dynamic-container").classList.add('transition-hide')
            setTimeout(() => {
                if (direction === 'forward') {
                    if (step < maxStep)
                        setStep(step + 1)
                } else if (direction === 'back') {
                    if (step > 0)
                        setStep(step - 1)
                }
                document.querySelector(".dynamic-container").classList.remove('transition-hide')
            }, 1000);
        } else {
            setToastMsg(verify())
            setSeverity('error')
            setOpen(true)
        }
    }

    const [amount, setAmount] = useState(1500000)
    const [businessOperatingTime, setBusinessOperatingTime] = useState(null)
    const [monthlyRevenue, setMonthlyRevenue] = useState(null)
    const [creditScore, setCreditScore] = useState(null)
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastName] = useState('')
    const [businessName, setBusinessName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const referrals = ["Andrew Torres", "Austin Cornielle", "Bryce Madlock", "Cezar Miranda", "Christian Alcantar", "Christian Rossi", "Cooper Postma", "Daniel Farcas", "Dolan Klingenberg", "Dominic Barrenger", "Eduardo Atayde", "Frank Akins", "Hailey Ames", "Hector Veloz", "Holden Macedo", "Jade Hess", "James Mahone", "Jaime Sabines", "Jessica Moreno", "Jojuan Silva", "Joe averdink", "Joshua Munoz", "Justin Crum", "Juwon Ware", "Keith Crum", "Kelsey Anderson", "Kendall Brown", "Moe Rashed", "Moises Santos", "Octavio Romero", "Quiani Mcgee", "Richard Marin", "Salim Jackson", "Sean Preibe", "Sharkey Elena", "Toland Walton", "Zadi Garber", "Other"]
    const [referral, setReferral] = useState(referrals[0])


    const verify = (direction) => {
        if (direction === 'back') {
            return true
        } else if (step === 0) {
            return true
        } else if (step === 1) {
            if (businessOperatingTime)
                return true
            else
                return 'Select an option'
        } else if (step === 2) {
            if (monthlyRevenue)
                return true
            else
                return 'Select an option'
        } else if (step === 3) {
            if (creditScore)
                return true
            else
                return 'Select an option'
        } else if (step === 4) {
            if (creditScore)
                return true
            else
                return 'Select an option'
        }
    }

    const businessOperatingTimes = [
        'Less than 3 months',
        '3-5 months',
        '6–12 months',
        '1-2 years',
        '2-5 years',
        'More than 5 years',
        'I currently don’t own a business'
    ]

    const monthlyRevenues = [
        'Less than $1,000',
        "$1,000 – $5,000",
        "$5,000 – $15,000",
        "$15,000 – $20,000",
        "$20,000 – $30,000",
        "$30,000 – $50,000",
        "$50,000 – $100,000",
        "$100,000 – $200,000",
        "$200,000+"
    ]

    const creditScores = [
        "500 and below",
        "500-549",
        "550-599",
        "600-649",
        "650-719",
        "720 or above",
        "Not sure"
    ]


    return (
        <div className="careers-page">
            <Toast open={open} setOpen={setOpen} severity={severity} timer={4000}>{msg}</Toast>
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Apply for Business Funding
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            Get business funding with flexible terms and fast approvals.
                        </Typography>
                        <Spacebox padding="20px" />
                        {step < 5 && <div className="mid margin-auto" style={{ padding: isMobile ? '0px' : '20px', borderRadius: '10px', border: isMobile ? '0px solid transparent' : '1px solid #4A3FFF20' }}>
                            <div>
                                <div onClick={() => {
                                    changeStep('back')
                                }} className="pointer" style={{ opacity: step > 0 ? 1 : 0, visibility: step > 0 ? 'visible' : 'hidden' }} >
                                    <Flexbox alignItems="center">
                                        <ChevronLeft style={{ color: 'var(--primary)', fontSize: '17px' }} />
                                        <Spacebox padding="2.5px" />
                                        <small style={{ color: 'var(--primary)' }}><b>Back</b></small>
                                    </Flexbox>
                                </div>
                                <Spacebox padding="5px" />
                            </div>
                            <div style={{ overflow: 'hidden' }}>
                                <div className="dynamic-container">
                                    {step === 0 && (
                                        <div>
                                            <Typography style={{ textAlign: 'center' }}>
                                                {!type && <b>Scroll to select your loan amount</b>}
                                                {type && <b>Type to enter your loan amount</b>}
                                            </Typography>
                                            <Spacebox padding="5px" />
                                            {!type && <Slider
                                                aria-label="Default"
                                                defaultValue={5000000}
                                                step={5000}
                                                min={10000}
                                                max={10000000}
                                                value={amount}
                                                onChange={(e, value) => setAmount(value)}
                                                color="primary"
                                            />}
                                            {type && (
                                                <div className="margin-auto" style={{ width: isMobile ? '100%' : "70%" }}>
                                                    <small>Amount</small>
                                                    <Spacebox padding="5px" />
                                                    <input
                                                        value={amount}
                                                        onChange={(e) => setAmount(e.target.valueAsNumber)}
                                                        placeholder="Loan Amount"
                                                        type="number"
                                                    />
                                                </div>
                                            )}
                                            <Spacebox padding="10px" />
                                            <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '30px' : '40px' }}>
                                                ${(amount).toLocaleString()}
                                            </Typography>
                                            <Spacebox padding="10px" />
                                            <Flexbox justifyContent="center">
                                                <Button handleClick={() => {
                                                    setType(!type)
                                                }} style={{ background: 'var(--primary)', color: 'white', borderRadius: '5px', padding: '7px 15px' }} className="">
                                                    <small style={{ fontSize: '15px', color: 'white' }}>
                                                        {type ? "Use slider instead" : "Type Amount Instead"}
                                                    </small>
                                                </Button>
                                            </Flexbox>
                                        </div>
                                    )}
                                    {step === 1 && (
                                        <div>
                                            <Typography style={{ textAlign: 'center' }}>
                                                <b>Business Operating Time</b>
                                            </Typography>
                                            <Spacebox padding="20px" />
                                            <Grid grid={isMobile ? 1 : 2} gap="20px">
                                                {businessOperatingTimes.map((ans, i) => (
                                                    <div key={i} style={{ background: ans === businessOperatingTime ? '#000' : 'transparent', color: ans === businessOperatingTime ? 'white' : 'black', border: '1px solid #00000030', borderRadius: '5px', cursor: 'pointer', padding: '20px' }} onClick={() => setBusinessOperatingTime(ans)} >
                                                        {ans}
                                                    </div>
                                                ))}
                                            </Grid>
                                        </div>
                                    )}
                                    {step === 2 && (
                                        <div>
                                            <Typography style={{ textAlign: 'center' }}>
                                                <b>Gross Monthly Revenue?</b>
                                            </Typography>
                                            <Spacebox padding="20px" />
                                            <Grid grid={isMobile ? 1 : 2} gap="20px">
                                                {monthlyRevenues.map((ans, i) => (
                                                    <div key={i} style={{ background: ans === monthlyRevenue ? '#000' : 'transparent', color: ans === monthlyRevenue ? 'white' : 'black', border: '1px solid #00000030', borderRadius: '5px', cursor: 'pointer', padding: '20px' }} onClick={() => setMonthlyRevenue(ans)} >
                                                        {ans}
                                                    </div>
                                                ))}
                                            </Grid>
                                        </div>
                                    )}
                                    {step === 3 && (
                                        <div>
                                            <Typography style={{ textAlign: 'center' }}>
                                                <b>Personal Credit Score? (Provide your best estimate)</b>
                                            </Typography>
                                            <Spacebox padding="20px" />
                                            <Grid grid={isMobile ? 1 : 2} gap="20px">
                                                {creditScores.map((ans, i) => (
                                                    <div key={i} style={{ background: ans === creditScore ? '#000' : 'transparent', color: ans === creditScore ? 'white' : 'black', border: '1px solid #00000030', borderRadius: '5px', cursor: 'pointer', padding: '20px' }} onClick={() => setCreditScore(ans)} >
                                                        {ans}
                                                    </div>
                                                ))}
                                            </Grid>
                                        </div>
                                    )}
                                    {step === 4 && (
                                        <div>
                                            <Typography style={{ textAlign: 'center' }}>
                                                <b>Input your basic business information below!</b>
                                            </Typography>
                                            <div style={{ textAlign: 'center' }}>
                                                <span style={{ opacity: .6 }}>And get your loan offer now.</span>
                                            </div>
                                            <Spacebox padding="20px" />
                                            <Grid grid={2} gap="20px">
                                                <input
                                                    value={firstname}
                                                    onChange={(e) => setFirstname(e.target.value)}
                                                    placeholder="First Name"
                                                />
                                                <input
                                                    value={lastname}
                                                    onChange={(e) => setLastName(e.target.value)}
                                                    placeholder="Last Name"
                                                />
                                            </Grid>
                                            <Spacebox padding="10px" />
                                            <input
                                                value={businessName}
                                                onChange={(e) => setBusinessName(e.target.value)}
                                                placeholder="Legal Business Name"
                                            />
                                            <Spacebox padding="10px" />
                                            <input
                                                value={email}
                                                type="email"
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="Email Address"
                                            />
                                            <Spacebox padding="10px" />
                                            <input
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && submit()}
                                                placeholder="Mobile Phone Number"
                                            />
                                            <select
                                                style={{ display: 'none' }}
                                                value={referral}
                                                onChange={(e) => setReferral(e.target.value)}
                                            >
                                                {referrals.map((ref, i) => (
                                                    <option key={i} value={ref}>{ref}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <Spacebox padding="20px" />
                            <Flexbox justifyContent="space-between" alignItems="center">
                                <div>
                                    <small style={{ opacity: .5 }}><b>{step + 1} of {maxStep + 1}</b></small>
                                    <Spacebox padding="2.5px" />
                                    <div style={{ width: '100px', height: '7px', borderRadius: '1000px', background: '#4A3FFF20', overflow: 'hidden' }}>
                                        <div style={{ width: `${((step + 1) / (maxStep + 1)) * 100}%`, height: '100%', background: 'var(--primary)', borderRadius: '1000px' }}></div>
                                    </div>
                                </div>

                                <div>
                                    <Button handleClick={() => {
                                        if (step === 4)
                                            submit()
                                        else
                                            changeStep('forward')
                                    }} style={{ background: 'var(--primary)', color: 'white', borderRadius: '5px', padding: '7px 15px' }} className="">
                                        {!loading && <Flexbox alignItems="center">
                                            <small style={{ fontSize: '15px', color: 'white' }}>
                                                {step === maxStep ? 'Submit' : 'Next'}
                                            </small>
                                            <Spacebox padding="5px" />
                                            <ChevronRight style={{ color: 'white', fontSize: '15px' }} />
                                        </Flexbox>}
                                        {loading && (
                                            <Ring size={15} speed={0.9} color={"white"} />
                                        )}
                                    </Button>
                                </div>
                            </Flexbox>
                        </div>}
                        {step === 5 && <Flexbox justifyContent="center" alignItems="center" className="margin-auto" style={{ padding: isMobile ? '0px' : '20px', borderRadius: '10px', border: isMobile ? '0px solid transparent' : '1px solid #4A3FFF20', height: '500px', width: isMobile ? '100%' : '700px' }}>
                            <Flexbox justifyContent="center" alignItems="center">
                                <b>Thank You</b>
                                <Spacebox padding="5px" />
                                <Divider flexItem orientation="vertical" style={{opacity: .6}} />
                                <Spacebox padding="5px" />
                                <small>Your details have been submitted successfully</small>
                            </Flexbox>
                        </Flexbox>}
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
        </div>
    );
}

export default ApplyNow;